export default __webpack_public_path__ + "static/0315-3d2d135e19f1aa768442074658a4dc99.png";